import { UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { endPointUrls } from 'core/constants/endPointUrls';
import toastHandler from 'core/helpers/toast/toast';
import useMutationHook from 'core/hooks/masterQuery/useMutationHook';
import api from 'core/services/fetch-api/useApi';
import { setApiCatcherFormErrors } from 'core/store/slice/mainInfo/mainInfoSlice';
import { useDispatch } from 'react-redux';

export const useOrderSubmitQuery = () => {
	const dispatch = useDispatch();
	const queryClient = useQueryClient();

	return useMutationHook(
		[endPointUrls.ORDER_SUBMIT],
		(data: any) => api.post(endPointUrls.ORDER_SUBMIT, data),
		{
			onSuccess: (res) => {
				queryClient.invalidateQueries([endPointUrls.WALLETS]);
				queryClient.invalidateQueries([endPointUrls.PROFILE_MANAGEMENT]);
				queryClient.invalidateQueries([endPointUrls.ORDERS()]);

				const response = res as AxiosResponse;

				if (response?.status === 200) {
					toastHandler('success', response?.data.message);
					// callBack?.();
					dispatch(setApiCatcherFormErrors([]));
				}
			},
		}
	) as UseMutationResult<any>;
};
